import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import meetingService from '../services/meetingService';
import MeetingWindow from '../components/VideoCall/MeetingWindow';
import './MeetingInvite.css';

const MeetingInvite = () => {
    const { token } = useParams();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [joining, setJoining] = useState(false);
    const [error, setError] = useState('');
    const [meeting, setMeeting] = useState(null);
    const [invite, setInvite] = useState(null);
    const [tokens, setTokens] = useState(null);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        meetingService.getPublicInvite(token)
            .then(response => {
                if (!mounted) return;
                setMeeting(response.data?.meeting || null);
                setInvite(response.data?.invite || null);
                setError('');
            })
            .catch(err => {
                if (!mounted) return;
                setError(err.message || 'This meeting invite is no longer available.');
            })
            .finally(() => mounted && setLoading(false));

        return () => {
            mounted = false;
        };
    }, [token]);

    const joinMeeting = async () => {
        setJoining(true);
        setError('');
        try {
            const response = await meetingService.joinPublicInvite(token, searchParams.get('occurrence_date'));
            setTokens(response.data?.tokens || null);
            setMeeting(response.data?.meeting || meeting);
        } catch (err) {
            setError(err.message || 'Unable to join this meeting.');
        } finally {
            setJoining(false);
        }
    };

    const formatDateTime = (value) => {
        if (!value) return '-';
        return new Date(value).toLocaleString(undefined, {
            dateStyle: 'medium',
            timeStyle: 'short',
        });
    };

    if (tokens && meeting) {
        return <MeetingWindow meeting={meeting} tokens={tokens} onClose={() => setTokens(null)} />;
    }

    return (
        <main className="meeting-invite-page">
            <section className="meeting-invite-panel">
                {loading ? (
                    <div className="meeting-invite-state">Loading invite...</div>
                ) : error ? (
                    <div className="meeting-invite-state meeting-invite-error">{error}</div>
                ) : meeting ? (
                    <>
                        <div className="meeting-invite-header">
                            <span className="meeting-invite-status">{invite?.status || 'sent'}</span>
                            <h1>{meeting.title}</h1>
                        </div>
                        {meeting.description && <p className="meeting-invite-description">{meeting.description}</p>}
                        <dl className="meeting-invite-details">
                            <div>
                                <dt>Organizer</dt>
                                <dd>{meeting.organizer?.name || '-'}</dd>
                            </div>
                            <div>
                                <dt>Starts</dt>
                                <dd>{formatDateTime(meeting.start_at)}</dd>
                            </div>
                            <div>
                                <dt>Ends</dt>
                                <dd>{formatDateTime(meeting.end_at)}</dd>
                            </div>
                            <div>
                                <dt>Location</dt>
                                <dd>{meeting.is_online ? 'Online meeting' : (meeting.location || '-')}</dd>
                            </div>
                        </dl>
                        {meeting.is_online ? (
                            <button className="meeting-invite-join" onClick={joinMeeting} disabled={joining}>
                                {joining ? 'Joining...' : 'Join Meeting'}
                            </button>
                        ) : (
                            <div className="meeting-invite-state">This is an in-person meeting.</div>
                        )}
                    </>
                ) : null}
            </section>
        </main>
    );
};

export default MeetingInvite;
